<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <b-link :to="{name:'dashboard'}">Admin</b-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
      </ol>
    </nav>

    <judging-progress/>

    <div class="pt-5 text-center px-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 673 698"
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="454.88"
            y1="346.96"
            x2="454.88"
            y2="390.02"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.31" stop-color="#fff"></stop>
            <stop offset="1" stop-color="#ccc"></stop>
          </linearGradient>
          <linearGradient
            id="linear-gradient-2"
            x1="454.88"
            y1="214.61"
            x2="454.88"
            y2="257.67"
            xlink:href="#linear-gradient"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-3"
            x1="448.38"
            y1="480.67"
            x2="448.38"
            y2="523.73"
            xlink:href="#linear-gradient"
          ></linearGradient>
          <linearGradient
            id="linear-gradient-4"
            x1="454.88"
            y1="84.98"
            x2="454.88"
            y2="128.04"
            xlink:href="#linear-gradient"
          ></linearGradient>
        </defs>
        <title>funnel</title>
        <g id="funnel">
          <rect class="cls-1" x="262" y="347" width="385" height="45.33"></rect>
          <rect class="cls-2" x="262" y="214" width="385" height="45.33"></rect>
          <rect class="cls-3" x="249" y="480" width="398" height="45.33"></rect>
          <rect class="cls-4" x="262" y="85" width="385" height="45.33"></rect>
          <circle class="cls-5" cx="648" cy="105" r="25"></circle>
          <circle class="cls-5" cx="648" cy="235" r="25"></circle>
          <circle class="cls-5" cx="648" cy="367" r="25"></circle>
          <circle class="cls-5" cx="648" cy="501" r="25"></circle>
          <g>
            <polygon class="cls-5" points="220 396 249 526 360 487 380 396 220 396"></polygon>
            <polygon class="cls-5" points="0 0 0 41 0 41 66 130 534 130 600 41 600 41 600 0 0 0"></polygon>
            <polygon class="cls-5" points="69 134 163 260 437 260 531 134 69 134"></polygon>
            <polygon class="cls-5" points="165 263 205 327 219 392 381 392 395 327 435 263 165 263"></polygon>
          </g>
          <text class="cls-6" transform="translate(640 245)">2</text>
          <text class="cls-6" transform="translate(640 378)">3</text>
          <text class="cls-6" transform="translate(640 511)">4</text>
          <text class="cls-6" transform="translate(640 115)">1</text>
          <text class="cls-7" transform="translate(244 485)">{{entrantsCompletedEntryCount}}</text>
          <text class="cls-7" transform="translate(244 352)">{{entrantsWithPhotosCount}}</text>
          <text class="cls-7" transform="translate(244 223)">{{entrantsCount}}</text>
          <text class="cls-7" transform="translate(244 89)">{{registrationsCount}}</text>
          <text class="cls-8" transform="translate(246 418)">Completed</text>
          <text class="cls-9" transform="translate(246 286)">Uploaded a Photo</text>
          <text class="cls-8" transform="translate(246 156)">Started Entry</text>
          <text class="cls-8" transform="translate(246 23)">Registered</text>
          <text class="cls-12" transform="translate(514 243)">{{ratioEnteredRegistered}}</text>
          <text class="cls-12" transform="translate(482 371)">{{ratioUploadedPhotoRegistered}}</text>
          <text class="cls-12" transform="translate(458 505)">{{ratioCompletedRegistered}}</text>
        </g>
        <g id="metrics">
          <text class="cls-13" transform="translate(1 675)">{{startedEntriesCount}}</text>
          <text class="cls-14" transform="translate(32 613)">Entries Started</text>
          <text class="cls-13" transform="translate(239 675)">{{photosUploadedCount}}</text>
          <text class="cls-14" transform="translate(267 613)">Photos Uploaded</text>
          <text class="cls-13" transform="translate(492 675)">{{completedEntriesCount}}</text>
          <text class="cls-14" transform="translate(519 613)">Entries Completed</text>
          <circle class="cls-15" cx="502" cy="607" r="10"></circle>
          <line class="cls-15" x1="505" y1="603" x2="510" y2="613"></line>
          <line class="cls-15" x1="500" y1="603" x2="512" y2="603"></line>
          <line class="cls-15" x1="498" y1="607" x2="503" y2="597"></line>
          <line class="cls-15" x1="500" y1="611" x2="494" y2="601"></line>
          <line class="cls-15" x1="505" y1="611" x2="493" y2="611"></line>
          <line class="cls-15" x1="507" y1="607" x2="501" y2="617"></line>
          <path
            class="cls-16"
            d="M4,606s4-8,11-8,11,8,11,8-4,8-11,8S4,606,4,606Z"
            transform="translate(-3 0)"
          ></path>
          <circle class="cls-16" cx="12" cy="606" r="3"></circle>
          <rect class="cls-15" x="239" y="597" width="18" height="18" rx="2"></rect>
          <circle class="cls-15" cx="245" cy="603" r="2"></circle>
          <polyline class="cls-15" points="257 609 252 604 241 615"></polyline>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import JudgingProgress from '@/components/judging/JudgingProgress.vue'
export default {
  components: { JudgingProgress },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    isLoading() {}
  },
  computed: {
    ...mapGetters({
      completedEntriesCount: 'admin/completedEntriesCount',
      entrantsCompletedEntryCount: 'admin/entrantsCompletedEntryCount',
      entrantsCount: 'admin/entrantsCount',
      entrantsWithPhotosCount: 'admin/entrantsWithPhotosCount',
      photosUploadedCount: 'admin/photosUploadedCount',
      registrationsCount: 'admin/registrationsCount',
      startedEntriesCount: 'admin/startedEntriesCount'
    }),
    ratioEnteredRegistered: getters => {
      let ratio = (getters.entrantsCount / getters.registrationsCount) * 100
      return `${Math.round(ratio)}%`
    },
    ratioUploadedPhotoRegistered: getters => {
      let ratio =
        (getters.entrantsWithPhotosCount / getters.registrationsCount) * 100
      return `${Math.round(ratio)}%`
    },
    ratioCompletedRegistered: getters => {
      let ratio =
        (getters.entrantsCompletedEntryCount / getters.registrationsCount) * 100
      return `${Math.round(ratio)}%`
    }
  }
}
</script>
    <style>
svg {
  max-width: 680px;
}
.cls-1 {
  fill: url(#linear-gradient);
}

.cls-2 {
  fill: url(#linear-gradient-2);
}

.cls-3 {
  fill: url(#linear-gradient-3);
}

.cls-4 {
  fill: url(#linear-gradient-4);
}

.cls-12,
.cls-13,
.cls-14,
.cls-5 {
  fill: #343a40;
}

.cls-6 {
  font-size: 30px;
}

.cls-6,
.cls-7,
.cls-8,
.cls-9 {
  fill: #fff;
}

.cls-13,
.cls-14,
.cls-6,
.cls-7,
.cls-8,
.cls-9 {
  font-family: HelveticaNeue, Helvetica Neue;
}

.cls-13,
.cls-7 {
  font-size: 48px;
}

.cls-14,
.cls-8 {
  opacity: 0.7;
}

.cls-14,
.cls-8,
.cls-9 {
  font-size: 18px;
}

.cls-9 {
  opacity: 0.64;
}

.cls-10 {
  letter-spacing: -0.02em;
}

.cls-11 {
  letter-spacing: 0em;
}

.cls-12 {
  font-size: 21.76px;
  font-family: HelveticaNeue-Bold, Helvetica Neue;
  font-weight: 700;
}

.cls-15,
.cls-16 {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}

.cls-15 {
  stroke: #343a40;
}

.cls-16 {
  stroke: #000;
}
</style>
